import {createSvgIcon} from '@logistics-frontend/blocks/icons/utils'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(29.125)};
  block-size: ${spacing(10.625)};
`
export default createSvgIcon(
  <svg
    className="footer__icon"
    fill="none"
    height="85"
    viewBox="0 0 233 85"
    width="233"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 50.3636L189.671 50.3636L170.523 70L189.671 70L216 43L189.671 16L170.523 16L189.671 35.6364L21 35.6364L21 50.3636Z"
      fill="white"
    />
    <rect height="83" rx="11" stroke="white" strokeWidth="2" width="231" x="1" y="1" />
  </svg>,
  'ArrowSquare',
  {viewBox: '0 0 233 85', className},
)
